/** Explorer version from the build (package version, `+<short sha>` when built by CI). */
export const EXPLORER_VERSION: string = __EXPLORER_VERSION__;
